import React, { ReactNode } from "react";

interface InfoCardProps {
    title: string;
    children: ReactNode;
    actionButton?: ReactNode;
}

export const InfoCard: React.FC<InfoCardProps> = ({
    title,
    children,
    actionButton,
}) => (
    <div className="_telascard">
        <h1 className="_telascard-title">{title}</h1>
        {actionButton}
        <div className="_telascard-content">{children}</div>
    </div>
);
